export default {
  aggregations: {},
  groups: [],
  fullText: [],
  fullTextCheck: 0,
  query: '',
};
